export type DetailKind = 'proveedor' | 'distribucion' | 'transporte' | 'pago';

/** Clasificación ABC del SKU. '' = sin definir (el campo es opcional). */
export type AbcValue = '' | 'A' | 'B' | 'C';

/** Opciones seleccionables de ABC (excluye '' / sin definir). */
export const ABC_OPTIONS: Exclude<AbcValue, ''>[] = ['A', 'B', 'C'];

export const DETAIL_LABEL: Record<DetailKind, string> = {
	proveedor: 'Proveedor',
	distribucion: 'Distribución',
	transporte: 'Transporte',
	pago: 'Método de pago',
};

export const DETAIL_ORDER: DetailKind[] = [
	'proveedor',
	'distribucion',
	'transporte',
	'pago',
];

export type ProductProveedor = {
	codigo: string;
	/**
	 * Código del proveedor en el ERP (`vendorCode` de la carga a Profit).
	 * Aparte de `codigo`, que es un falso amigo: casi siempre trae la
	 * referencia del proveedor (`#3013TL-card`), no un código de Profit.
	 */
	codigoErp: string;
	descripcion: string;
	descripcionProductoProveedor: string;
	/** Par 1:1 con nombreContacto: si viene uno, debe venir el otro */
	email: string;
	/** Par 1:1 con email */
	nombreContacto: string;
	/** Texto libre, sin catálogo */
	pais: string;
};

export type ProductDistribucion = {
	costoFobUnidad: string;
	costoFobBulto: string;
	unidadDespacho: string;
	conteoDespacho: string;
	/** Almacén destino en el ERP (`warehouseCode` de la carga a Profit). */
	codigoAlmacen: string;
};

export type ProductTransporte = {
	cpe: string;
	codigoArancelario: string;
	moq: string;
	tiempoPromedioProduccion: string;
	puerto1: string;
	puerto2: string;
	puerto3: string;
};

export type ProductMetodoPago = {
	advance: string;
	balance: string;
};

export type ProductUnitOfMeasure = {
	producto: string;
	codigoUnidad: string;
	totalUnidades: string;
	codigoBarra: string;
	alto: string;
	ancho: string;
	largo: string;
	peso: string;
};

export type ProductMasterRow = {
	id: string;
	codigo: string;
	descripcion: string;
	categoria: string;
	linea: string;
	sublinea: string;
	/** Sub-línea en inglés (atributo del maestro, no viene de datamart) */
	sublineaEn: string;
	/** Clasificación ABC del SKU: sólo 'A' | 'B' | 'C' (o '' si no está definida) */
	abc: AbcValue;
	estado: string;
	proveedor: ProductProveedor;
	distribucion: ProductDistribucion;
	transporte: ProductTransporte;
	metodoPago: ProductMetodoPago;
	unidadesMedida: ProductUnitOfMeasure[];
	/** Ej.: Maquila — Producto Terminado (catálogo de negocio) */
	tipoMaterial: string;
};
